"use client";

import { DiscountCodes } from "@/features/diets/components/discount-codes";
import { LengthDiscountBadge } from "@/features/diets/components/length-discount-badge";
import { getMaxLengthDiscount } from "@/features/diets/helpers/get-max-length-discount";
import type { DietCatalog, DietCatalogDetail } from "@/features/diets/types";

/**
 * Discount badges of the diet card. They sit above the diet name — diet type
 * tags are not shown here any more, they live in the diet info dialog.
 */
export const DietCardBadges = ({
  diet,
}: {
  diet: DietCatalog | DietCatalogDetail;
}) => {
  const hasDiscountCodes = (diet.discountCodes?.length ?? 0) > 0;
  const maxLengthDiscount = getMaxLengthDiscount(diet.lengthDiscounts);

  if (!(hasDiscountCodes || diet.lengthDiscounts)) return null;

  return (
    <div className="flex flex-wrap gap-1.5">
      <DiscountCodes discountCodes={diet.discountCodes} />
      {diet.lengthDiscounts && (
        <LengthDiscountBadge maxDiscount={maxLengthDiscount} />
      )}
    </div>
  );
};
